export const COLLAPSIBLE_ARRAOW_ICON_SIZE = 10;
export const ICON_SIZE_IN_PIXEL = 16;
export const ICON_SIZE = 18;

export const AD_FEATURE_TABS_SCROLL_END_TOLERANCE = 10;
